import { useQuery } from 'react-query'

import { QueryKey } from '../../../common/api'
import { permissionsApi } from '../api/permissions.api'

export const useGetPermissions = () => {
  return useQuery([QueryKey.Permissions], async () => {
    const response = await permissionsApi.getPermissions()

    return response.data
  })
}
